/*
 * @Author: your name
 * @Date: 2021-11-27 16:57:06
 * @LastEditTime: 2021-12-29 11:27:33
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /eventsEditor/projects/events-editor/src/lib/events-editor.component.ts
 */
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { InternalCommand, SavedCommandChanged } from './events-editor.interface';
import { cloneDeep } from 'lodash-es';
import { NotifyService } from '@farris/ui-notify';
import { EventsEditorUtil } from '../events-editor-utils';
import { eventEditorLocale } from './entity/locale';
@Component({
  selector: 'farris-eventsEditor',
  templateUrl: './events-editor.component.html',
  styleUrls: ['./events-editor.component.css']
})

export class EventsEditorComponent implements OnInit {
  /** 入参 */
  @Input() initialData: InternalCommand;
  /** 出参 */
  @Output() savedCommandListChanged = new EventEmitter<any>();
  /** 入参数据处理-生成内部使用的层级结构 */
  originalData: Array<any> = [];
  /** original的i值 */
  i: any;
  /** 事件-显示下拉框内容 */
  showComboList: boolean = false;
  /** 事件-用户选择的事件展示顺序 */
  eventsDisplayOrder: Array<any> = [];
  /** 方法来源-下拉框中用户选择绑定的变量:前缀+方法名+数字 */
  currentCommand: Array<any> = [];
  /** 展示浮层 */
  showPopover: boolean = false;
  /** 引入控制器值变化事件 */
  newImport: boolean = false;
  /** 用户导入的新控制器 */
  addInternalCommandList: any;
  /** 判断导入新的方法后是否绑定了该控制器下的值 */
  exist: number = -1;
  /** 判断用户是否新增函数 */
  newFunc: boolean = false;
  /** 检查「已有方法」中是否有值 */
  haveBoundCommand: boolean = false;
  /** 国际化命令名称 */
  eventInternation;
  localeId;
  eventEditorLocale = eventEditorLocale;

  constructor(public notifySer: NotifyService) { }

  ngOnInit() {
    // 判断当前环境
    this.getLanguageEnvironment();
    //重置切换到代码视图的标识
    this.resetDataVmLabel();
    //移除已绑定的事件
    this.resetBoundEvents();
    //根据设定的规则，确定可选的目标组件的范围 
    this.initTargetComponent();
    //得到原始数据
    this.getOriginalData();
  }

  getLanguageEnvironment() {
    if (window) {
      if (window.top) {
        if (window.top.localStorage) {
          this.localeId = window.top.localStorage.languageCode || 'zh-CHS';
        }
      }
    }
  }
  /** 重置切换到代码视图的标识 */
  public resetDataVmLabel() {
    this.initialData['isAddControllerMethod'] = false;
  }

  /** 移除已绑定的事件 */
  public resetBoundEvents() {
    const eventsFunc = this.initialData.getEventList();
    const events = eventsFunc.events;
    this.initialData.events = cloneDeep(events);
    //在触发事件面包交互按钮时，重新收集所有的绑定事件
    if (eventsFunc) {
      if (eventsFunc.boundEventsList) {
        this.initialData.boundEventsList = eventsFunc.boundEventsList;
      }
    }
    if (this.initialData.boundEventsList) {
      this.initialData.boundEventsList = this.initialData.boundEventsList.filter(function (boundEventsListItem) {
        return events.find(event => event.label == boundEventsListItem.boundEvents.label)
      })
    }
  }

  /** 目标组件：根据设定的规则，确定可选的目标组件的范围 */
  public initTargetComponent() {
    const allComponentList = this.initialData.allComponentList;
    // 若componentLists为空，不显示目标组件下拉框（hasPath=false），默认添加到自己的viewmodel下
    if (this.initialData.componentLists.length && this.initialData.viewModel) {
      this.initialData.viewModel.forEach(controllerItem => {
        controllerItem.controllerList.forEach(commandItem => {
          if (commandItem['targetComponent']) {
            //判断targetComponent的vm是否和控件所在vm相同
            const componentList = allComponentList.find(componentListsItem => componentListsItem.componentId == commandItem.targetComponent);
            const targetVmId = componentList ? componentList.viewModelId : undefined;
            if (targetVmId == this.initialData.viewModelId) {
              //一段式
              commandItem.hasPath = false;
            }
            else {
              //三段式
              const hasPath = EventsEditorUtil.isContextDependent(controllerItem.controllerName.id, commandItem.handlerName);
              commandItem.hasPath = hasPath ? true : commandItem.hasPath;
              commandItem.componentLists = hasPath ? cloneDeep(this.initialData.componentLists) : commandItem.componentLists;
            }
          }
        });
      })
    }
    if (this.initialData.componentLists.length && this.initialData.boundEventsList) {
      this.initialData.boundEventsList.forEach(boundEventsListItem => {
        if (boundEventsListItem.controllerList['targetComponent']) {
          const componentList = allComponentList.find(componentListsItem => componentListsItem.componentId == boundEventsListItem.controllerList['targetComponent']);
          const targetVmId = componentList ? componentList.viewModelId : undefined;
          if (targetVmId == this.initialData.viewModelId) {
            //一段式
            boundEventsListItem.controllerList['hasPath'] = false;
          }
          else {
            //三段式
            const hasPath = EventsEditorUtil.isContextDependent(boundEventsListItem.controllerName['id'], boundEventsListItem.controllerList['handlerName']);
            boundEventsListItem.controllerList['hasPath'] = hasPath ? true : boundEventsListItem.controllerList['hasPath'];
            boundEventsListItem.controllerList['componentLists'] = hasPath ? cloneDeep(this.initialData.componentLists) : boundEventsListItem.controllerList['componentLists'];
          }
        }
      })
    }
    this.initialData = cloneDeep(this.initialData);
  }
  /** 得到原始数据 */
  public getOriginalData() {
    let unboundEvents;
    //1. 筛选出已绑定事件，保留未绑定事件用于事件下拉框展示
    if (this.initialData.boundEventsList.length != 0) {
      unboundEvents = cloneDeep(this.getEventsArray());
      this.initBoundEvents(unboundEvents);
    }
    //2. 若没有事件存在绑定值，则直接将所有事件放在「新建交互」下拉框
    else {
      unboundEvents = cloneDeep(this.initialData.events);
    }
    this.initUnboundEvents(unboundEvents);
  }
  /** 得到原始数据-1.组合「新建交互」下拉框展示值; 
  */
  public getEventsArray() {
    let eventsArray = cloneDeep(this.initialData.events || []);
    this.initialData.boundEventsList.forEach(boundEventsListItem => {
      this.initialData.events.forEach(function (eventsItem, index) {
        //如果events列表中有已绑定的事件，则用已空数组来替换原有的数据,仅保留没有选择参数的事件
        if (boundEventsListItem.boundEvents.label == eventsItem.label) { eventsArray.splice(index, 1, []) }
      })
    });
    eventsArray = eventsArray.filter(function (eventsArrayItem) { return eventsArrayItem.length != 0 })
    return eventsArray;
  }
  /** 得到原始数据-2.生成已绑定值的数据 */
  public initBoundEvents(unboundEvents) {
    let count = 0;
    this.initialData.boundEventsList.forEach(boundEventsListItem => {
      let newFrame = {
        /** 当前事件名称及label */
        events: {
          label: boundEventsListItem.boundEvents.label,
          name: boundEventsListItem.boundEvents.name,
        },
        /** 「新建交互」下拉框可选择的事件列表 */
        eventsArray: cloneDeep(unboundEvents),
        /** 内置构件方法列表 */
        internalCommandList: cloneDeep(this.initialData.internalCommandList),
        /** 控制组件的展示及顺序:
         * 0：事件下拉框
         * 1：事件名称
         * 2：来源+方法列表
         * 3：方法名
         * 4：方法参数*/
        showSwitch:
          [{//存储所有的展示设定
            showSection: [[false, false, false, false, false], [false, false, true, false, false], [false, true, false, true, false]],
            //展示哪个部分
            showSwitchNumber: 2,
          }],
        /** 方法列表 */
        currentCommand: cloneDeep(boundEventsListItem.controllerList),
        /** 当前的控制器 */
        currentControllerName: cloneDeep(boundEventsListItem.controllerName),
        /** 运行时定制环境下需要禁止编辑,该值为false，表明不禁止编辑，可以删改 */
        // editProhibitedInRuntimeCustom: this.handleEditStatesInRuntimeCustom(boundEventsListItem),
      }
      //记录绑定的事件顺序id：0，1，2
      this.eventsDisplayOrder.push(cloneDeep(count));
      count++;
      this.originalData.push(cloneDeep(newFrame));
    })
  }
  /** 得到原始数据-3.生成未绑定值的事件的数据 */
  public initUnboundEvents(unboundEvents) {
    unboundEvents = unboundEvents || [];
    unboundEvents.forEach(unboundEventsItem => {
      let newFrame = {
        /** 事件 */
        events: {
          label: unboundEventsItem.label,
          name: unboundEventsItem.name
        },
        /** 「新建交互」下拉框可选择的事件列表 */
        eventsArray: cloneDeep(unboundEvents),
        /** 内置构件方法列表 */
        internalCommandList: cloneDeep(this.initialData.internalCommandList),
        /** 控制组件的展示及顺序:
         * 对应showSwitch的显示部分
         * 0：事件下拉框 
         * 1：事件名称
         * 2：来源+方法列表
         * 3：方法名
         * 4：方法参数 */
        showSwitch:
          [{
            /** showSwitch为true的部分（选择绑定事件：0 ->选择方法来源及绑定方法1,2 ->参数编辑1,3）*/
            showSection: [[true, false, false, true, false], [false, true, true, false, false], [false, true, false, false, true]],
            showSwitchNumber: 0,
          }],
        /** 方法列表 */
        currentCommand: [],
        /** 当前的控制器 */
        currentControllerName: [],
      }
      this.originalData.push(cloneDeep(newFrame));
    })
  }

  /** 运行时定制-判断是否需要禁止编辑 */
  // public handleEditStatesInRuntimeCustom(boundEventsListItem) {
  //   // 判断为运行时定制环境
  //   if (this.initialData.envType == 'runtimeCustom') {
  // isRTCmd = true 表明为运行时定制的命令，可以删改, 不禁用编辑
  //   if (boundEventsListItem.controllerList['isRTCmd']) {
  //     return false;
  //   }
  //   // isRTCmd = undefined||false 表明应该禁用编辑
  //   else {
  //     return true;
  //   }
  // }
  //   // 非运行时定制环境，不禁止编辑
  //   return false;
  // }

  /** 新建交互 */
  public createNewInteraction() {
    if (this.initialData.getEventList) {
      let result = cloneDeep(this.initialData.getEventList());
      this.refreshInternals(result);
      this.refreshEventsList(result);
    }
    //检查是否显示「已有方法」组件
    if (this.initialData.getEventPath) {
      if (this.initialData.getEventPath().actionWithPath.length != 0) {
        this.haveBoundCommand = true;
      } else {
        this.haveBoundCommand = false;
      }
    }
    if (this.originalData.length != 0) {
      //1. 展示事件下拉框
      if (this.originalData[0].eventsArray.length != 0) {
        this.showComboList = !this.showComboList;
        // 2. 自动收折其他已展示的方法列表
        this.originalData.forEach(originalDataItem => {
          originalDataItem.showSwitch.forEach(showSwitchItem => {
            showSwitchItem.showSection[2][4] = false;
          });
        })
      }
      //4.特殊情况予以提示
      else {
        const info = eventEditorLocale[this.localeId].eventsEditor.allBound;
        this.notifySer['info'](info);
      }
    }
    else {
      const info = eventEditorLocale[this.localeId].eventsEditor.noBoundEvents;
      this.notifySer['info'](info);
    }
  }
  /** 新建交互-1.根据getEventList，即时更新内置构件中的控制器 */
  public refreshInternals(result) {
    this.originalData.forEach(originalDataItem => {
      originalDataItem.internalCommandList = cloneDeep(result.internalCommandList);
    })
    this.initialData.internalCommandList = cloneDeep(result.internalCommandList);
  }

  /** 新建交互-2.根据getEventList，即时更新事件列表 */
  public refreshEventsList(result) {
    //若数目相同，则查看是否都为相同事件
    if (result.events.length != this.originalData.length) {
      let newEventsArray;
      // //如果originalData长度为0
      if (this.originalData.length == 0) {
        newEventsArray = [];
        this.initUnboundEvents(result.events);
        result.events.forEach(eventList => {
          newEventsArray.push(cloneDeep(eventList));
        })
      }
      // //如果originalData中有值
      else {
        let sameEvent = [];
        let differEvent = [];
        result.events.forEach(event => {
          const eventExist = this.originalData.find(originalDataItem => originalDataItem.events.label === event.label);
          if (eventExist) {
            sameEvent.push(cloneDeep(event));
          }
          else {
            differEvent.push(cloneDeep(event));
          }
        });
        let updatedOriginalData = [];
        if (sameEvent.length != 0) {
          sameEvent.forEach(sameEventItem => {
            this.originalData.forEach(originalDataItem => {
              if (sameEventItem.label == originalDataItem.events.label) {
                updatedOriginalData.push(cloneDeep(originalDataItem))
              }
            })
          })
          //将顺序于boundEvents对应
          this.eventsDisplayOrder = [];
          const self = this;
          updatedOriginalData.forEach(function (originalDataItem, index) {
            self.initialData.boundEventsList.forEach(boundEventItem => {
              if (boundEventItem.boundEvents.label == originalDataItem.events.label)
                //记录绑定的事件顺序id：0，1，2
                self.eventsDisplayOrder.push(index);
            })
          })
          this.originalData = cloneDeep(updatedOriginalData);
        }
        if (differEvent.length != 0) {
          this.initUnboundEvents(differEvent);
        }
      }
      let eventsArray = cloneDeep(result.events);
      this.initialData.boundEventsList.forEach(boundEventsListItem => {
        this.initialData.events.forEach(function (eventsItem, index) {
          //如果events列表中有已绑定的事件，则用已空数组来替换原有的数据,仅保留没有选择参数的事件
          if (boundEventsListItem.boundEvents.label == eventsItem.label)
            eventsArray.splice(index, 1)
        })
      });
      this.originalData.forEach(originalDataItem => {
        originalDataItem.eventsArray = cloneDeep(eventsArray);
      })
    }
    this.initialData.events = cloneDeep(result.events);
  }

  /** 事件-绑定事件
   * 1. 收折其他已展示的事件列表；
   * 2. 关闭「新建交互」下拉框；
   * 3. 用户选择的事件记录到eventsDisplayOrder;
   * 4. 显示浮层*/
  public bindEvents(originalDataItem, commandItemIndex, i) {
    this.i = i;
    //1. 收折其他已展示的事件列表
    this.originalData.forEach(eachOriginalData => {
      eachOriginalData.showSwitch.forEach(showSwitchItem => {
        showSwitchItem.showSection[2][3] = false;
      });
    })
    //2. 关闭「新建交互」下拉框
    this.showComboList = false;
    //3. 选择过的事件无法再次被选择
    this.deleteSelectedEvents(originalDataItem);
    for (let m = 0; m < this.originalData.length; m++) {
      if (this.originalData[m].events.label == originalDataItem.label) {
        //4. 用户选择的事件记录到eventsDisplayOrder,倒序插入
        this.eventsDisplayOrder.unshift(cloneDeep(m));
        this.i = m;
        //为展示机制重新赋值，删除后当前事件的显示showSwitch可能为空
        if (this.originalData[m].showSwitch) {
          this.originalData[m].showSwitch[commandItemIndex].showSwitchNumber = 1;
          this.originalData[m].showSwitch[commandItemIndex].showSection[2][3] = true;
        }
      }
    }
    //5. 显示浮层
    this.showPopover = true;
  }

  /** 事件-事件列表处理：选择过的事件无法再次被选择 */
  public deleteSelectedEvents(chosedItem) {
    this.originalData.forEach(originalDataItem => {
      originalDataItem.eventsArray.forEach(function (each, index) {
        if (each.label == chosedItem.label) { originalDataItem.eventsArray.splice(index, 1); }
      });
    })
  }

  /** 事件-事件收折：隐藏方法列表 */
  public hideCurrentCommandList(i) {
    // 仅显示事件名称；
    this.originalData[i].showSwitch.forEach(showSwitchItem => {
      showSwitchItem.showSection[2][3] = !showSwitchItem.showSection[2][3];
    });
  }

  /** 事件-事件删除：
   * 1.删除当前事件
   * 2. eventsDisplayOrder增加已删除的事件的序号 */
  public deleteCurrentEvent(i) {
    this.initialData['preCommand'] = cloneDeep(this.originalData[i].currentCommand);
    this.originalData[i].currentCommand = [];
    // showSwitch置为初始值
    this.originalData[i].showSwitch = [];
    this.originalData[i].showSwitch.push(cloneDeep(
      {
        showSection: [[true, false, false, true, false], [false, true, true, false, false], [false, true, false, true, false]],
        showSwitchNumber: 0,
      }
    ))

    let middleEventsDisplayOrderData = this.eventsDisplayOrder;
    middleEventsDisplayOrderData.forEach(function (element, index) {
      if (element == i) { middleEventsDisplayOrderData.splice(index, 1); }
    });
    this.eventsDisplayOrder = cloneDeep(middleEventsDisplayOrderData);

    // 若事件中的方法为空，则事件列表中增加此项，且应在曾经删除的位置；
    for (let m = 0; m < this.initialData.events.length; m++) {
      if (this.initialData.events[m].label == this.originalData[i].events.label) {
        this.originalData.forEach(originalDataItem => {
          //确认事件对应位置
          originalDataItem.eventsArray.splice(m + 1, 0, this.originalData[i].events);
        });
      }
    }
    //值传出事件
    this.onOriginalDataChanged(this.originalData, i);
  }

  /** 方法-方法替换 */
  public onCurrentCommandNumChanged(i, originalData) {
    this.initialData['preCommand'] = cloneDeep(originalData[i].currentCommand);
    //根据getEventList，即时更新内置构件中的控制器列表
    if (this.initialData.getEventList) {
      let result = cloneDeep(this.initialData.getEventList());
      this.refreshInternals(result);
    }
    if (this.initialData.getEventPath) {
      if (this.initialData.getEventPath().actionWithPath.length != 0) {
        this.haveBoundCommand = true;
      } else {
        this.haveBoundCommand = false;
      }
    }
    this.originalData = cloneDeep(originalData)
    this.i = i;
    //重新确认当前页面的展示部分
    this.originalData[i].showSwitch = [];
    this.originalData[i].showSwitch.push(cloneDeep({
      showSection: [[false, false, false, false, false], [false, true, true, false, false], [false, true, false, true, false]],
      //展示哪个部分
      showSwitchNumber: 1,
    }));
    //展示浮层
    this.showPopover = true;
  }

  /** 方法-导入新方法值变化事件 */
  public onNewImportChanged(value) {
    this.newImport = value;
    this.initTargetComponent();
  }

  /** 内置构件选择“导入新方法”后的值 */
  public onAddInternalCommandListChanged(value) {
    this.addInternalCommandList = cloneDeep(value);
  }

  /** 方法来源关闭按钮事件 */
  public onClosed(i) {
    this.originalData[i].showSwitch = [];
    this.originalData[i].showSwitch.push(cloneDeep({
      //存储所有的展示设定
      showSection: [[false, false, false, false, false], [false, false, true, false, false], [false, true, false, true, false]],
      //展示哪个部分
      showSwitchNumber: 2,
    }));
    //关闭浮层
    this.showPopover = false;
    this.originalData = cloneDeep(this.originalData);
    //若当前事件下没有新增任何方法，则直接删除此事件，并重构事件列表；
    if (this.originalData[i].currentCommand.length == 0) {
      this.deleteCurrentEvent(i);
    }
  }

  public onExistChanged(value: number) {
    this.exist = value;
  }

  /** 方法绑定-下拉框中用户选择绑定的变量 */
  public onCurrentCommandChanged(currentCommand, i, commandItemIndex) {
    this.i = i;
    this.currentCommand = cloneDeep(currentCommand);
    this.originalData[i].showSwitch[commandItemIndex].showSwitchNumber = 2;
    //除当前用户点击的这一项展开之外，其余全部收折
    this.originalData[i].showSwitch[commandItemIndex].showSection[2][4] = true;
    //关闭浮层
    this.showPopover = false;
    this.newFunc = false;
  }

  /** 原始数据值变化事件 */
  public onOriginalDataChanged(value, i) {
    this.i = i;
    this.originalData = cloneDeep(value);
    this.newFunc = false;
    // 传出时机：
    // 1.用户输入值变化（不中断值的输入过程）；
    // 2.用户清空方法参数值；
    // 3.用户导入新方法后的内置构件部分；
    // 4.用户选择事件后绑定了方法；
    // 5.用户删除事件；
    /** 传出当前页面的用户绑定变量 */
    this.emitFinalState();
  }

  public onNewFucChanged() {
    this.newFunc = true;
    this.initialData['isAddControllerMethod'] = true;
    this.emitFinalState();
  }

  /** 如果最后用户绑定的方法中有新增的控制器，则传出该方法控制器相关参数 */
  public emitNewController(boundEventsList: any) {
    let newController = [];
    this.initialData.newController.forEach(newControllerItem => {
      boundEventsList.forEach(boundEventsListItem => {
        if (newControllerItem.Code = boundEventsListItem.controllerName.label) {
          newController.push(cloneDeep(newControllerItem));
        }
      })
    });
    return newController;
  }

  /** 值传出事件 */
  public emitFinalState() {
    if (!this.newImport) {
      if (!this.newFunc) {
        this.initialData['isAddControllerMethod'] = this.initialData['newFuncEvents'] ? true : false;
      }
      const boundEventsList = [];
      let internalCommandList = cloneDeep(this.initialData.internalCommandList);
      if (this.originalData) {
        //生成事件绑定值列表
        internalCommandList = cloneDeep(this.originalData[0].internalCommandList);
        this.eventsDisplayOrder.forEach(item => {
          const currentInterface = {
            controllerName: {},
            controllerList: {},
            boundEvents: {},
          }
          currentInterface.controllerName = cloneDeep(this.originalData[item].currentControllerName);
          currentInterface.controllerList = cloneDeep(this.originalData[item].currentCommand);
          currentInterface.boundEvents = cloneDeep(this.originalData[item].events);
          boundEventsList.push(cloneDeep(currentInterface));
        });
      }
      let newController = [];
      newController = this.initialData.newController.length && boundEventsList.length ? cloneDeep(this.emitNewController(boundEventsList)) : newController;
      //传出前更新repititionCommand的值
      if (this.initialData['repititionCommand']) {
        this.initialData['repititionCommand'] = this.updateRepititionCommand(boundEventsList);
      }
      //当前界面显示的所有事件
      let savedCommandList: SavedCommandChanged = {
        /** 拼接名称时的前缀 */
        viewModelId: this.initialData.viewModelId,
        /** 视图模型绑定的事件下的方法列表 */
        savedCommand: cloneDeep(this.initialData.viewModel),
        /** 当前界面显示的绑定事件 */
        boundEventsList: cloneDeep(boundEventsList),
        /** 可选择的绑定事件列表 */
        events: cloneDeep(this.initialData.events),
        /** 内置构件列表； */
        internalCommandList: cloneDeep(internalCommandList),
        /** 所有可选的组件 */
        componentLists: [],
        /** 接收this.formBasicService.formMetaBasicInfo.relativePath */
        relativePath: this.initialData.relativePath,
        /** 接收this.formBasicService.envType */
        envType: this.initialData.envType,
        /** 初始为空，用于存储用户点击「导入新方法」的控制器值 */
        newController: cloneDeep(newController),
        /** 切换到代码视图标识 */
        isAddControllerMethod: this.initialData.isAddControllerMethod,
        /** 用户选择「已有方法」 */
        repititionCommand: this.initialData['repititionCommand'],
        /** 上一个绑定的方法 */
        preCommand: this.initialData['preCommand'],
        /** 新增方法的对应事件 */
        newFuncEvents: cloneDeep(this.initialData['newFuncEvents']),
      }
      //值传出事件
      this.savedCommandListChanged.emit(savedCommandList);
    }
  }

  /** 传出前更新repititionCommand的值 */
  public updateRepititionCommand(boundEventsList) {
    if (this.initialData.repititionCommand.length != 0) {
      this.initialData.repititionCommand.forEach(repititionCommandItem => {
        boundEventsList.forEach(boundEventsListItem => {
          if (repititionCommandItem.command.id == boundEventsListItem.controllerList['id']) {
            repititionCommandItem.command.params = cloneDeep(boundEventsListItem.controllerList['property']);
            const targetComponent = boundEventsListItem.controllerList['targetComponent'];
            boundEventsListItem.controllerList['componentLists'].forEach(componentListsItem => {
              repititionCommandItem.targetComponent = componentListsItem.componentId == targetComponent ? {
                id: componentListsItem.componentId,
                viewModelId: componentListsItem.viewModelId
              } : repititionCommandItem.targetComponent;
            });
          }
        })
      });
      return this.initialData.repititionCommand;
    }
    return undefined;
  }
  /**
   * 事件展示顺序追踪处理器
   * @param index 索引
   * @param item 当前遍历对象
   * @returns 
   */
  public eventsDisplayOrderTrackByHandler(index: number, item: any) {
    return item;
  }
  /**
   * 是否展示追踪处理器
   * @param index 索引
   * @param item 当前项
   * @returns 
   */
  public showSwitchTrackByHandler(index: number, item: any) {
    if (item && Array.isArray(item)) {
      return item.map(flag => flag === true ? 1 : 0).join('');
    } else {
      return undefined;
    }
  }

}